export default "__VITE_PUBLIC_ASSET__9d9700a9__"